/**
 * Global Search Redux Slice
 */

import { createSlice, type PayloadAction } from '@spcc/core'
import type { GlobalSearchState, SearchResult, PortalType } from '../domain/types'

const initialState: GlobalSearchState = {
  query: '',
  results: [],
  total: 0,
  isLoading: false,
  error: null,
  isOpen: false,
  portal: 'customer',
}

const globalSearchSlice = createSlice({
  name: 'globalSearch',
  initialState,
  reducers: {
    setPortal(state, action: PayloadAction<PortalType>) {
      state.portal = action.payload
    },
    openSearch(state) {
      state.isOpen = true
    },
    closeSearch(state) {
      state.isOpen = false
      state.query = ''
      state.results = []
      state.total = 0
      state.error = null
    },
    setQuery(state, action: PayloadAction<string>) {
      state.query = action.payload
    },
    searchRequest(state, action: PayloadAction<string>) {
      state.isLoading = true
      state.error = null
      state.query = action.payload
    },
    searchSuccess(
      state,
      action: PayloadAction<{ results: SearchResult[]; total: number }>
    ) {
      state.isLoading = false
      state.results = action.payload.results
      state.total = action.payload.total
    },
    searchFailure(state, action: PayloadAction<string>) {
      state.isLoading = false
      state.error = action.payload
    },
    clearSearch(state) {
      state.query = ''
      state.results = []
      state.total = 0
      state.error = null
    },
  },
})

export const globalSearchActions = globalSearchSlice.actions
export const globalSearchReducer = globalSearchSlice.reducer
